const normalizePath = (value: string): string => {
  if (!value.startsWith('/')) {
    return `/${value}`
  }

  return value
}

/**
 * agency-saas is subdomain-only — the tenant context is carried by the
 * hostname, never by a URL prefix. withTenantPrefix is therefore a
 * pass-through, kept only so leftover call sites (AppShell community/manage
 * nav items inherited from zth) keep compiling. See useCommunityLinks.ts
 * for the architectural rationale.
 */
export const useTenantPaths = () => {
  const withTenantPrefix = (path: string): string => {
    return normalizePath(path)
  }

  return {
    withTenantPrefix
  }
}
